import { render, staticRenderFns } from "./AdminTMA.vue?vue&type=template&id=2b7b4650&"
import script from "./AdminTMA.vue?vue&type=script&lang=js&"
export * from "./AdminTMA.vue?vue&type=script&lang=js&"
import style0 from "./AdminTMA.vue?vue&type=style&index=0&id=2b7b4650&prod&lang=scss&"
import style1 from "./AdminTMA.vue?vue&type=style&index=1&id=2b7b4650&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports